import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import ValidatedField, {
  type S as ValidatedFieldSig
} from 'ui-kit/components/validated-field';
import TimePicker, { type Signature as TimePickerSig } from '../time-picker';

interface Signature {
  Args: Pick<ValidatedFieldSig['Args'], 'propertyName' | 'changeset'> &
    Pick<
      TimePickerSig['Args'],
      'isReadOnly' | 'isMandatory' | 'disabled' | 'labelName'
    >;
}

const ChangesetTimePicker: TOC<Signature> = <template>
  <ValidatedField
    @propertyName={{@propertyName}}
    @changeset={{@changeset}}
    @errorClass='error-validated-input-display'
  >
    <TimePicker
      @propertyName={{@propertyName}}
      @selected={{changesetGet @changeset @propertyName}}
      @isReadOnly={{@isReadOnly}}
      @disabled={{@disabled}}
      @labelName={{@labelName}}
      @isMandatory={{@isMandatory}}
      @onChange={{fn (changesetSet @changeset @propertyName)}}
    />
  </ValidatedField>
</template>;

export default ChangesetTimePicker;
